export default "__VITE_ASSET__BmKaQy1l__"